<template>
  <div class="bx-epg-select__tags">
    <strong>Gefiltert nach:</strong>
    <template v-for="({ filterName, value, label }) in selectedFilterLabels"
              :key="filterName + value">
      <button v-if="label"
              type="button"
              :title="getTitle(filterName, value)"
              @click.prevent="removeFilter(filterName, value)">
        {{ label }}
        <Icon v-if="!notRemovable(filterName, value)"
              name="close" />
      </button>
    </template>
  </div>
</template>

<script>
import Icon from '../../../../../components/shared/Icon.vue'

export default {
  components: { Icon },
  props: {
    selectedFilters: {
      type: Object,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  emits: ['remove-filter'],
  computed: {
    /**
     * Returns an array of selected filter labels.
     * Each label is an object containing the filter name, value, and label.
     */
    selectedFilterLabels () {
      return Object.entries(this.selectedFilters).flatMap(([filterName, values]) => {
        // if the value is an array (e.g. categoryIds), then map each element
        if (Array.isArray(values)) {
          return values.map(value => ({
            filterName,
            value,
            label: this.getFilterLabel(filterName, value)
          }))
        }

        // if it's a single value, process normally
        return {
          filterName,
          value: values,
          label: this.getFilterLabel(filterName, values)
        }
      })
    }
  },
  methods: {
    /**
     * Returns the label for a given filter name and value.
     * If the label is 'Alle', it returns null.
     * Otherwise, it returns the selectedTagLabel or the label.
     */
    getFilterLabel (filterName, value) {
      const found = this.filters[filterName]?.find(item => item.value === value)
      return found && found.label !== 'Alle' ? found.selectedTagLabel || found.label : null
    },

    /**
     * Checks if a filter is not removable.
     * A filter is not removable if it has a default value.
     */
    notRemovable (filterName, value) {
      return this.filters[filterName].find(item => item.value === value)?.default
    },

    /**
     * Emits an event to remove a filter.
     * If the filter is not removable, it does nothing.
     */
    removeFilter (filterName, value) {
      if (this.notRemovable(filterName, value)) return
      this.$emit('remove-filter', { filterName, value })
    },

    /**
     * Returns the title for a given filter name and value.
     * If the filter is not removable, it returns a standard filter message.
     * Otherwise, it returns a message to remove the filter.
     */
    getTitle (filterName, value) {
      return this.notRemovable(filterName, value)
        ? `Standard Filter '${this.getFilterLabel(filterName, value)}'`
        : `Filter '${this.getFilterLabel(filterName, value)}' entfernen`
    }
  }
}
</script>
